import { IconPencil } from "../icons/IconPencil";

export function ButtonPencil({
  onClick,
  disabled,
  title,
}: {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-100 hover:bg-gray-200 dark:bg-zinc-700 dark:hover:bg-zinc-600 border border-gray-300 dark:border-zinc-600 text-gray-600 dark:text-zinc-300 transition disabled:opacity-50 disabled:cursor-not-allowed"
      title={title ?? "Edit"}
      onClick={onClick}
      disabled={disabled}
    >
      <IconPencil />
    </button>
  );
}
